<div class="row">
    <div class="col-12 col-md-6">
        <div class="table-container mat-elevation-z2">
            <div class="loading-shade"
                 *ngIf="isLoadingResults || error">
                <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                <div class="error" *ngIf="error">
                    An error has occurred, please try again later.
                </div>
            </div>

            <mat-table mat-table [dataSource]="dataSource" matSort>
                <ng-container matColumnDef="Name">
                    <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="Name" (click)="select(element)">
                        {{element.name}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Desc">
                    <mat-header-cell *matHeaderCellDef>Desc</mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="Desc" (click)="select(element)">
                        {{element.desc || 'nothing yet'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Color">
                    <mat-header-cell *matHeaderCellDef class="centered">Color</mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="Color" (click)="select(element)">
                        <div class="color"
                             [matTooltip]="element.color || 'nothing yet'"
                             [ngStyle]="{'backgroundColor': element.color}"
                        ></div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Badge">
                    <mat-header-cell *matHeaderCellDef>Badge</mat-header-cell>
                    <mat-cell *matCellDef="let element" data-label="Badge" (click)="select(element)">
                        {{element.badge || 'nothing yet'}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Actions">
                    <mat-header-cell *matHeaderCellDef class="centered">Actions</mat-header-cell>
                    <mat-cell class="centered" *matCellDef="let element; let i = index;" data-label="Actions">
                        <button mat-button (click)="delete(element, i)" [disabled]="saving || isUndeleteable(element)">
                            <mat-icon matSuffix matTooltip="Delete">delete</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
        </div>
        <button mat-flat-button color="accent" class="add-btn mat-elevation-z2" (click)="createMode()">
            <mat-icon>add</mat-icon>
        </button>

    </div>
    <div class="col-12 col-md-6">
        <div class="mat-elevation-z2 panel">
            <div class="role-editor">
                <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input name="name" [(ngModel)]="selectedRole.name" [disabled]="isEdit" type="text" matInput
                           placeholder="monea"
                           autocomplete="off">
                    <mat-icon matSuffix>grade</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Description</mat-label>
                    <input name="desc" [(ngModel)]="selectedRole.desc" type="text" matInput
                           placeholder="this makes you bald"
                           autocomplete="off">
                    <mat-icon matSuffix>subject</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Badge</mat-label>
                    <input disabled name="badge" [(ngModel)]="selectedRole.badge" type="text" matInput
                           placeholder="idk yet"
                           autocomplete="off">
                    <mat-icon matSuffix>local_laundry_service</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline">
                    <mat-label>Color</mat-label>
                    <input name="badge" [(ngModel)]="selectedRole.color" type="text" matInput
                           placeholder="#000"
                           autocomplete="off">
                    <div class="color-preview" matSuffix [ngStyle]="{'backgroundColor':selectedRole.color}"></div>
                </mat-form-field>
                <app-permission (OnRemove)="onPermissionRemove($event)" (OnAdd)="onPermissionAdd($event)"
                                [permissions]="selectedRole.permissions"></app-permission>
                <button mat-flat-button color="accent" (click)="save()"
                        [disabled]="saving">
                    {{saving ? 'Saving' : isEdit ? 'Save' : 'Create'}}
                </button>
            </div>
        </div>
    </div>
</div>
